
import Vue from "vue";
import { BROWSE_ACCESS_LEVELS, BrowseAccessLevel, BrowseButton, BrowsePermissions } from "../../models/user-configs/browse-permissions";

interface IButtonOption {
	key: string;
	label: string;
	requires: string;
	disabled: boolean;
	value: boolean;
	set: (value:boolean)=>void;
}

export default Vue.extend({
	data() {
		return {
			advancedOpen: false
		};
	},
	props: {
		permissions: {
			type: Object as ()=> BrowsePermissions,
			required: true
		},
		name: {
			type: String,
			required: true
		},
		buttonsOnly: Boolean,
		expandAll: Boolean
	},
	computed: {
		levels():BrowseAccessLevel[] {
			return BROWSE_ACCESS_LEVELS;
		},
		level():BrowseAccessLevel {
			return this.permissions.getAccessLevel();
		},
		writeWithoutRead():boolean {
			return !this.permissions.CanRead && this.level != "none";
		},
		lowerName():string {
			if (this.name == this.name.toUpperCase()) return this.name;
			return this.name.charAt(0).toLowerCase() + this.name.slice(1);
		},
		description():string {
			let key = this.writeWithoutRead ? "write-without-read" : this.level;
			return this.$ct("module-access.descriptions." + key, {name: this.lowerName}).toString();
		},
		hasWrite():boolean {
			return this.permissions.hasWritePermissions();
		},
		hasDelete():boolean {
			return this.permissions.hasDeletePermissions();
		},
		buttonOptions():IButtonOption[] {
			let options:IButtonOption[] = [
				this.browseButtonOption("info", false, false),
				this.browseButtonOption("add", true, false),
				this.browseButtonOption("edit", true, false),
				this.browseButtonOption("duplicate", true, false),
			];
			if (!this.buttonsOnly) {
				options.push({
					key: "views",
					label: this.$ct("module-access.option-labels.views").toString(),
					requires: this.requirementLabel(true, false),
					disabled: this.isDisabled(true, false),
					value: this.permissions.CanMakeViews,
					set: (value:boolean) => {
						this.permissions.CanMakeViews = value;
					}
				});
			}
			options.push(this.browseButtonOption("delete", true, true));
			return options;
		}
	},
	watch: {
		expandAll(value:boolean) {
			this.advancedOpen = value;
		}
	},
	methods: {
		browseButtonOption(button:BrowseButton, needsWrite:boolean, needsDelete:boolean):IButtonOption {
			return {
				key: button,
				label: this.$ct("module-access.option-labels." + button).toString(),
				requires: this.requirementLabel(needsWrite, needsDelete),
				disabled: this.isDisabled(needsWrite, needsDelete),
				value: !this.permissions.isButtonHidden(button),
				set: (value:boolean) => this.permissions.setButtonHidden(button, !value)
			};
		},
		requirementLabel(needsWrite:boolean, needsDelete:boolean):string {
			if (this.buttonsOnly) return "";
			if (needsDelete) return this.$ct("module-access.levels.full").toString();
			if (needsWrite) return this.$ct("module-access.levels.write").toString();
			return "";
		},
		isDisabled(needsWrite:boolean, needsDelete:boolean):boolean {
			if (this.buttonsOnly) return false;
			if (needsDelete) return !this.hasDelete;
			if (needsWrite) return !this.hasWrite;
			return false;
		},
		setLevel(level:BrowseAccessLevel) {
			this.permissions.setAccessLevel(level);
		}
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
